import React from "react";
import "../style/Section4.scss";
import blockMinorIcon from "../assets/images/pc/03_Timeline.png";
import SectionTitle from "../components/SectionTitle";

function Section4(props) {
  return (
    <div id={"Section4"}>
      <SectionTitle title={"TIMELINE"} />
      <div className="image-box">
        <img src={blockMinorIcon} alt="timeline" />
      </div>
    </div>
  );
}

export default Section4;
